/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { isUndefined } from 'lodash';
import { SegmentRule } from '../../defs/SegmentRule.defs';
import { SegmentRuleset } from '../../defs/SegmentRuleset.defs';
import { UISegmentRuleObject } from '../../defs/UISegmentRuleObject.defs';
import { UISegmentRuleProperties } from '../../defs/UISegmentRuleProperties.defs';

/**
 * Function to refactor the ruleset data returned by the API so it can be used in the UI.
 * @param {Array<SegmentRule>} rulesets Props passed to `createRulesets`.
 * @export
 * @returns {Array<UISegmentRuleObject>} Refactored API rulesets to be used in the Segment builder.
 */
export function createRulesets(rulesets: Array<SegmentRule>): Array<UISegmentRuleObject> {
  const newArrayOfRulesets: Array<UISegmentRuleObject> = [];
  rulesets.forEach((set, index) => {
    const { type, or } = set;
    const ruleOperator = isUndefined(or) ? `and` : `or`;
    const rules = set[ruleOperator] as Array<UISegmentRuleProperties>;

    rules.forEach((rule) => {
      rule.id = window.crypto.randomUUID(); // Add ID specific to individual rules for targeting within the UI.
    });

    newArrayOfRulesets.push({
      id: index.toString(),
      operator: ruleOperator,
      rules,
      type,
    });
  });
  return newArrayOfRulesets;
}

export const defaultRulesets: SegmentRuleset = {
  and: [
    {
      and: [
        {
          comparison: '',
          id: '',
          property: '',
          type: '',
          value: '',
        },
      ],
    },
  ],
};
